/**
 * Script for Front Page
 *
 * @author Space-Time Inc.
 */


/**
 * Lists by Terms
 *
 * @author Space-Time Inc.
 */

(function () {
	const MAX_COUNT = 6;

	const root = document.querySelector('.part-dynamic-archive-filter');
	if (!root) return;
	const sel = root.querySelector('select');
	const all = root.querySelector('a.button');
	const as = document.querySelectorAll('.part-dynamic-archive-filter-term-archive a');

	const items = document.querySelectorAll('.list-item-news > li');

	let current = 'all';

	sel.removeAttribute('onchange');
	all.style.display = 'none';

	sel.addEventListener('change', () => {
		const val = sel.value;
		if ('#' === val) {
			current = 'all';
			all.style.display = 'none';
		}
		 else {
			const slug = sel.value.split('/').at(-1);
			current = 'news_category-' + slug;
			all.style.display = null;
		}
		
		for (const a of as) {
			if (a.dataset.type === current) {
				a.style.display = null;
			} else {
				a.style.display = 'none';
			}
		}
		set_item_visible(current, MAX_COUNT);
	});
	all.addEventListener('click', e => {
		e.preventDefault();
		all.style.display = 'none';
		sel.value = '#';
		current = 'all';
		set_item_visible(current, MAX_COUNT);
	});

	function set_item_visible(f, count) {
		let i = 0;
		for (; i < items.length; i += 1) {
			const it = items[i];

			const v = ('all' === f) || (it.classList.contains(f));

			if (v) {
				it.style.display = '';
				count -= 1;
			} else {
				it.style.display = 'none';
			}
			if (count === 0) break;
		}
		i += 1;
		for (; i < items.length; i += 1) {
			items[i].style.display = 'none';
		}
	}
	document.addEventListener('DOMContentLoaded', () => {
		set_item_visible('all', MAX_COUNT);
		const list = document.querySelector('.list-item-news');
		list.classList.remove('first-view');
	});
})();

function initialize(selector, fillStyle, height, len, amp) {
	const can = document.querySelector(selector);
	const ctx = can.getContext('2d');

	let t = new Tide(can.width, height, len, amp);

	var grd = ctx.createLinearGradient(0, 0, 1000, 800);
		grd.addColorStop(0, 'rgba(220,0,255,0.15)' );
		grd.addColorStop(1, 'rgba(86,0,240,0.3)');

		// Fill with gradient
		ctx.fillStyle = grd;
		ctx.fillRect(10, 10, 150, 80);

	function draw() {
		ctx.clearRect(0, 0, can.width, can.height);

		ctx.save();
		ctx.fillStyle =  grd;
		//ctx.fillStyle =  fillStyle;
		ctx.translate(0, can.height * 0.5);
		t.draw(ctx);
		t.update(0.5);
		ctx.fill();
		ctx.restore();

		requestAnimationFrame(draw);
	}
	requestAnimationFrame(draw);

	const ro = new ResizeObserver(es => {
		for (const e of es) {
			const can = e.target;
			can.width  = can.offsetWidth;
			can.height = can.offsetHeight;
			t = new Tide(can.width, height);
		}
	});
	ro.observe(can, { box: 'border-box' });
}

class Tide {
	#width  = 0;
	#height = 0;
	#len    = 0;

	#w1 = null;
	#w2 = null;

	#f = 0;

	constructor(width, height, len = 200, amp = 100) {
		this.#width  = width;
		this.#height = height;
		this.#len    = len;

		const num = Math.ceil(width / len) + 3;
		this.#w1 = new Wave(num, len, amp);
		this.#w2 = new Wave(num, len, amp);
	}

	draw(ctx) {
		ctx.beginPath();
		const offset = this.#len * 2;

		const { x0: x0_1 } = this.#w1.getPoints(0, -this.#height * 0.5)
		ctx.moveTo(x0_1 - offset, -this.#height * 0.5);
		for (let i = 0; i < this.#w1.getNum(); i += 1) {
			ctx.bezierCurveTo(...this.#w1.getPoints(i, -this.#height * 0.5, e => e - offset));
		}

		const { x0: x0_2 } = this.#w2.getPoints(0, this.#height * 0.5, e => (this.#width - e))
		ctx.lineTo(x0_2 + offset, this.#height * 0.5);
		for (let i = 0; i < this.#w2.getNum(); i += 1) {
			ctx.bezierCurveTo(...this.#w2.getPoints(i, this.#height * 0.5, e => (this.#width - e + offset)));
		}

		ctx.closePath();
	}

	update(t) {
		this.#w1.update(t);
		this.#w2.update(t);
	}
}

class Wave {
	#num   = 8;
	#len   = 100;
	#amp   = 100;
	#pairs = [];
	#lenF  = 0.01;
	#ampF  = 0.1;

	constructor(num, len, amp) {
		this.#num = num;
		this.#len = len;
		this.#amp = amp;

		let x0 = 0;
		let a  = this.#amp / (this.#len * 0.3);

		for (let i = 0; i < this.#num; i += 1) {
			const x1 = (i + 0.3) * this.#len + (this.#len * this.#lenF * Math.random());
			const x2 = (i + 0.6) * this.#len + this.#random(this.#len * this.#lenF);
			const x3 = (i + 1.0) * this.#len - (this.#len * this.#lenF * Math.random());
			const y1 = a * (x1 - x0);
			const y2 = y1 + this.#amp * this.#ampF * ((a < 0 ? -1 : 1) * Math.random());

			this.#pairs.push({ x0, x1, x2, x3, y1, y2, y1b: y1, y2b: y2, s: Math.random() });
			x0 = x3;
			a  = y2 / (x2 - x3);
		}
	}

	getNum() {
		return this.#num;
	}

	getPoints(i, offset, fn = e => e) {
		const { x0, x1, y1, x2, y2, x3 }   = this.#pairs[i];
		const { x1: x1n, y1: y1n } = this.#pairs?.[i + 1] ?? { x1: x3 + this.#len * 0.3, y1: y2 * -1 };

		const vs = [
			fn(x1)            , offset + y1,
			fn(x2)            , offset + y2,
			fn((x2 + x1n) / 2), offset + (y2 + y1n) / 2,
		];
		vs.x0 = fn(x0);
		return vs;
	}

	update(f) {
		for (let i = 0; i < this.#num; i += 1) {
			const { x0, x1, y1, x2, y2, x3, y3, y1b, y2b, s } = this.#pairs[i];
			const y1n = y1b * (0.5 + 0.5 * Math.sin(((f % 100) / 100 + s) * Math.PI * 2));
			const y2n = y2b + (y1n - y1b);
			this.#pairs[i] = { x0: x0 + 1, x1: x1 + 1, y1: y1n, x2: x2 + 1, x3: x3 + 1, y2: y2n, y1b, y2b, s };
		}
		const lp = this.#pairs.at(this.#num - 1);

		if (this.#num * this.#len < lp.x1) {
			this.#shift();
		}
	}

	#shift() {
		const p = this.#pairs.pop();
		const a = this.#amp / (this.#len * 0.3);

		p.x0 = 0;
		p.x1 = p.x0 + 0.3 * this.#len + (this.#len * this.#lenF * Math.random());
		p.x2 = p.x0 + 0.6 * this.#len + this.#random(this.#len * this.#lenF);
		p.x3 = p.x0 + 1.0 * this.#len - (this.#len * this.#lenF * Math.random());
		p.y1 = a * (p.x1 - p.x0);
		p.y2 = p.y1 + this.#amp * this.#ampF * ((a < 0 ? -1 : 1) * Math.random());

		this.#pairs.unshift(p);
	}

	#random(range = 1) {
		return range * (1 - 2 * Math.random());
	}
}


document.addEventListener('DOMContentLoaded', () => {
    initialize('#tide', 'rgba(149,0,226,0.3)', 300, 10, 100);
});
